import { createFileRoute, useParams } from "@tanstack/react-router"
import { scheduleQueryKeys } from "toptaal-shared"
import { OrganizationCalendarWithModal } from "@/components/modals/calendar/OrganizationCalendarWithModal"
import {
  fetchGroupAllSchedule,
  fetchGroupSchedule,
} from "@/api/services/groups"

export const Route = createFileRoute("/beheer/groepen/$groupId/lessen/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { groupId } = useParams({ from: "/beheer/groepen/$groupId" })

  return (
    <OrganizationCalendarWithModal
      id={Number(groupId)}
      getQueryKey={scheduleQueryKeys.group}
      queryFn={({ id, startDate, endDate }) =>
        fetchGroupSchedule({ id, startDate, endDate })
      }
      getAllScheduleQueryKey={scheduleQueryKeys.groupAllSchedule}
      getAllScheduleQueryFn={({ id }) => fetchGroupAllSchedule({ id })}
    />
  )
}
